export const brands: { [key: string]: { id: string; name: string; contactUrl: string; termsUrl: string; supportsDirectBooking: boolean } } =
    {
        novasol: {
            id: 'novasol',
            name: 'Novasol',
            contactUrl: 'https://www.novasol.no/hjelp',
            termsUrl: 'https://www.novasol.no/hjelp/generelle-vilkar-og-leiebetingelser',
            supportsDirectBooking: true,
        },
        interhome: {
            id: 'interhome',
            name: 'Interhome',
            contactUrl: 'https://www.interhome.no/kundeservice/',
            termsUrl: 'https://www.interhome.no/kundeservice/bestillingsvilkar/',
            supportsDirectBooking: true,
        },
        dancenter: {
            id: 'dancenter',
            name: 'DanCenter',
            contactUrl: 'https://www.dancenter.no/kontakt.html',
            termsUrl: 'https://www.dancenter.no/info/leiebetingelser/',
            supportsDirectBooking: true,
        },
        belvilla: {
            id: 'belvilla',
            name: 'Belvilla',
            contactUrl: 'https://www.belvilla.com/contact-us',
            termsUrl: 'https://www.belvilla.com/service',
            supportsDirectBooking: true,
        },
        sologstrand: {
            id: 'sologstrand',
            name: 'Sol og Strand',
            contactUrl: 'https://www.sologstrand.no/kundeservice',
            termsUrl: 'https://www.sologstrand.no/praktiske-info/bestillinger',
            supportsDirectBooking: true,
        },
        danland: {
            id: 'danland',
            name: 'Danland',
            contactUrl: 'https://www.danland.no/callback.html',
            termsUrl: 'https://www.danland.no/info/leiebetingelser/',
            supportsDirectBooking: true,
        },
        tui: {
            id: 'tui',
            name: 'Belvilla',
            contactUrl: 'https://www.belvilla.com/contact-us',
            termsUrl: 'https://www.belvilla.com/service#headingTop',
            supportsDirectBooking: true,
        },
        yourrentals: {
            id: 'yourrentals',
            name: 'Your.Rentals',
            contactUrl: 'mailto:bookings@your.rentals',
            termsUrl: 'https://s3.eu-central-1.amazonaws.com/yourrentals/yr-rental-term-for-guest.pdf',
            supportsDirectBooking: true,
        },
        norefjellhytta: {
            id: 'norefjellhytta',
            // They have changed their brand, but the ids are kept for now, as changing that would mean a larger
            // refactoring, probably including changing this in the database too.
            name: 'Unike Fjellhytter',
            contactUrl: 'mailto:utleie@unikefjellhytter.no',
            termsUrl: 'https://unikefjellhytter.no/bestilling-og-betaling/',
            supportsDirectBooking: true,
        },
        cabinliving: {
            id: 'cabinliving',
            name: 'Cabin Living',
            contactUrl: 'mailto:info@cabinliving.no',
            termsUrl: 'https://cabinliving.no/vilkar/',
            supportsDirectBooking: true,
        },
        campaya: {
            id: 'campaya',
            name: 'Campaya',
            contactUrl: 'support@campaya.no',
            termsUrl: 'https://www.campaya.no/kundeservice.cms',
            supportsDirectBooking: true,
        },
        bookingservicebeitostolen: {
            id: 'bookingservicebeitostolen',
            name: 'Booking Service Beitostølen',
            contactUrl: 'mailto:nicolay@bookingservice.no',
            termsUrl: 'https://www.bookingservice.no/vilkaar-for-booking/',
            supportsDirectBooking: true,
        },
    };

export const directBookingBrandsList = () => Object.values(brands).filter((brand) => brand.supportsDirectBooking);

export const isDirectBookingForBrandEnabled = (id: string) => directBookingBrandsList().some((brand) => brand.id === id);
